import React, {Component} from "react";
import {message} from "antd";

import {FONT_THEME_ID, RIGHT_SYMBOL} from "../../../utils/constant";
import {replaceStyle} from "../../../utils/helper";
import "../common.css";

class Font extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSerif: false,
    };
  }

  // 衬线字体 和 非衬线字体 切换
  toggleFont = () => {
    const {isSerif} = this.state;
    const serif = `#nice { 
      font-family: 'Songti SC', 'STSong', 'Noto Serif CJK SC', 'Source Han Serif SC', Georgia, 'Times New Roman', Times, serif;
    }`;
    const sansSerif = `#nice { 
      font-family: -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;
    }`;
    const choosen = isSerif ? serif : sansSerif;
    replaceStyle(FONT_THEME_ID, choosen);
    message.success("字体切换成功！");
    this.setState({isSerif: !isSerif});
  };

  render() {
    return (
      <div id="nice-menu-font" className="nice-menu-item" onClick={this.toggleFont}>
        <span>
          <span className="nice-menu-flag">{!this.state.isSerif && <span>{RIGHT_SYMBOL}</span>}</span>
          <span className="nice-menu-name">衬线字体</span>
        </span>
      </div>
    );
  }
}

export default Font;
